import { countryOptionsEn } from "./countryCodes/en"
import { countryOptionsTr } from "./countryCodes/tr"
import { countryOptionsDe } from "./countryCodes/de"
import { countryMapEn } from "./countryMap/en"
import { countryMapTr } from "./countryMap/tr"
import { countryMapDe } from "./countryMap/de"
import enLang from "./en.json"
import trLang from "./tr.json"
import deLang from "./de.json"

export const DEFAULT_LANGUAGE = "en"

export const getSelectedLanguage = () => {
  return localStorage.getItem("language") || DEFAULT_LANGUAGE
}

export const getLanguageJson = () => {
  const language = getSelectedLanguage()

  if (language === "tr") {
    return trLang
  } else if (language === "en") {
    return enLang
  } else if (language === "de") {
    return deLang
  } else {
    return enLang
  }
}

export const lang = getLanguageJson()

/**
 * The strings of one named language rather than the one the interface is set to, for text that has to
 * follow something else. The co-manager answers in the artist's language, which is not necessarily the
 * interface's, and our own strings inside that conversation follow the reply. An unknown or missing
 * language falls back to the selected one.
 */
export const getLanguageJsonFor = (language?: string | null) => {
  if (language === "tr") {
    return trLang
  } else if (language === "en") {
    return enLang
  } else if (language === "de") {
    return deLang
  } else {
    return getLanguageJson()
  }
}

export const getCountryCodeOptions = () => {
  const language = getSelectedLanguage()

  if (language === "tr") {
    return countryOptionsTr
  } else if (language === "en") {
    return countryOptionsEn
  } else if (language === "de") {
    return countryOptionsDe
  } else {
    return countryOptionsEn
  }
}

export const getCountryCodeMap = () => {
  const language = getSelectedLanguage()

  if (language === "tr") {
    return countryMapTr
  } else if (language === "en") {
    return countryMapEn
  } else if (language === "de") {
    return countryMapDe
  } else {
    return countryMapEn
  }
}

export const countryCodeOptions = getCountryCodeOptions()

export const countryCodeMap = getCountryCodeMap()
